"use strict";

var _core = require("../core");

var _logger = require("./logger");

(0, _core.setLogger)(_logger.logger);


//////////////////
// WEBPACK FOOTER
// ./~/react-query/lib/react/setLogger.js
// module id = 2023
// module chunks = 0